// MUST match SESSION_INFO_MESSAGE_TYPE in 0xSplits/splits-connect →
// src/utils/session-info.ts. The extension's content script listens for this
// message on the Teams origin and mirrors the session info into the
// extension popup.
const SESSION_INFO_MESSAGE_TYPE = 'splits-connect:setSessionInfo'

// MUST match CONNECTION_NETWORKS_MESSAGE_TYPE in 0xSplits/splits-connect →
// src/utils/site-network.ts. Same relay as the session info: the content
// script forwards it to the extension's background, which stores it for the
// popup's "Network for this site" control.
const CONNECTION_NETWORKS_MESSAGE_TYPE = 'splits-connect:setConnectionNetworks'

// Display-only fields. The posted message is observable by any script in the
// page (including broad-permission extensions like wallets), all of which can
// already read the same data from the DOM — never add tokens or secrets here.
// It goes no further than that: postMessage dispatches only on this window,
// so other tabs, sites, and extensions without access to this page never see
// it.
type SplitsConnectSessionInfo = {
  user: {
    name?: string
    email?: string
    avatarUrl?: string
  }
}

// Fire-and-forget: a harmless no-op when the extension is not installed.
// Pass null to clear the popup back to its signed-out state.
export const setExtensionSessionInfo = (
  sessionInfo: SplitsConnectSessionInfo | null,
) => {
  if (typeof window === 'undefined') return
  window.postMessage(
    { type: SESSION_INFO_MESSAGE_TYPE, sessionInfo },
    window.location.origin,
  )
}

// Site domain (the connect store's key, from getDomainFromUrl) → chain ids
// the connected team has enabled. Observable by any script on this origin,
// all of which can already read the connect store from localStorage.
export type SplitsConnectChainIdsByDomain = Record<string, number[]>

// Fire-and-forget: a harmless no-op when the extension is not installed.
export const setExtensionChainIdsByDomain = (
  chainIdsByDomain: SplitsConnectChainIdsByDomain,
) => {
  if (typeof window === 'undefined') return
  window.postMessage(
    { type: CONNECTION_NETWORKS_MESSAGE_TYPE, chainIdsByDomain },
    window.location.origin,
  )
}
